/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Createbusiness1Inputs */

const en_createbusiness1 = /** @type {(inputs: Createbusiness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Business`)
};

const de_createbusiness1 = /** @type {(inputs: Createbusiness1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen erstellen`)
};

/**
* | output |
* | --- |
* | "Create Business" |
*
* @param {Createbusiness1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const createbusiness1 = /** @type {((inputs?: Createbusiness1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Createbusiness1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_createbusiness1(inputs)
	return de_createbusiness1(inputs)
});
export { createbusiness1 as "createBusiness" }